import http from "@/utils/request";

const send = (method, data) =>
  http.sendRequest({
    METHOD_NAME: method,
    SECURITY_TYPE: "UserLogin",
    data,
    ERROR_CODE: {}
  });
const orders = prefix => ({
  pageQuery: request => send(prefix + ".pageQuery", { request }),
  load: id =>
    send(prefix + ".load", {
      [prefix === "warehouseReceiptInbound"
        ? "inboundOrderId"
        : "outboundOrderId"]: id
    }),
  create: request => send(prefix + ".create", { request }),
  importPreview: fileUrl => send(prefix + ".importPreview", { fileUrl }),
  batchImport: request => send(prefix + ".batchImport", { request }),
  createHezhu: request => send(prefix + ".createHezhu", { request }),
  cancel: id =>
    send(prefix + ".cancel", {
      [prefix === "warehouseReceiptInbound"
        ? "inboundOrderId"
        : "outboundOrderId"]: id
    }),
  sendWms: id =>
    send(prefix + ".sendWms", {
      [prefix === "warehouseReceiptInbound"
        ? "inboundOrderId"
        : "outboundOrderId"]: id
    })
});

export default {
  operations: {
    pageQuery: request =>
      send("warehouseReceiptOperation.pageQuery", { request }),
    load: operationId =>
      send("warehouseReceiptOperation.load", { operationId }),
    retryTransferCompletion: operationId =>
      send("warehouseReceiptOperation.retryTransferCompletion", {
        operationId
      }),
    confirmMerge: (operationId, remark) =>
      send("warehouseReceiptOperation.confirmMerge", {
        operationId,
        remark
      }),
    review: (operationId, status) =>
      send("warehouseReceiptOperation.review", { operationId, status })
  },
  currentUser: () => send("customsDeclare.loadOmsUserInfo", {}),
  inbound: {
    ...orders("warehouseReceiptInbound"),
    manualRelease: inboundOrderId =>
      send("warehouseReceiptInbound.manualRelease", { inboundOrderId })
  },
  outbound: {
    ...orders("warehouseReceiptOutbound"),
    prepareHezhu: outboundOrderId =>
      send("warehouseReceiptOutbound.prepareHezhu", { outboundOrderId })
  },
  accountBook: {
    stock: request =>
      send("warehouseReceiptAccountBook.pageQueryStock", { request }),
    occupancy: request =>
      send("warehouseReceiptAccountBook.pageQueryDeclarationFreeze", {
        request
      }),
    ledger: request =>
      send("warehouseReceiptAccountBook.pageQueryLedger", { request })
  },
  expiry: {
    stock: request =>
      send("warehouseReceiptExpiry.pageQueryStock", { request }),
    occupancy: request =>
      send("warehouseReceiptOutbound.pageQueryOccupancy", { request }),
    ledger: request =>
      send("warehouseReceiptExpiry.pageQueryLedger", { request })
  }
};
